import React, { useEffect, useState } from 'react'
import { Button } from '../../../components/button'
import { getApiKeys, deleteApiKey } from '../../../slices/apikeys'
import { useDispatch, useSelector } from 'react-redux';
import { ApiKeyStatus } from '../../../components/status';
import { Link, useNavigate } from "react-router-dom";
import { SvgRecycleBin } from '../../../components/svg';
import useModal from "../../../hooks/modal";
import Modal from '../../../components/modal';

const ApiKeys = () => {

    const dispatch = useDispatch()
    const apikeys = useSelector((state) => state.apikeys)
    const [isShowingDelete, toggleDelete] = useModal();
    const [apiKeyToDelete, setApiKeyToDelete] = useState(null);

    useEffect(() => {
        dispatch(getApiKeys())
    }, [])

    const showDeleteConfirm = (e, apiKey) => {
        e.stopPropagation()
        toggleDelete()
        setApiKeyToDelete(apiKey.prefix)
    }

    const confirmDelete = () => {
        dispatch(deleteApiKey(apiKeyToDelete)).then((response) => {
            dispatch(getApiKeys())
            toggleDelete()
        })
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">{gettext('API Keys')}</h1>
                        <Link to={"new"}><Button variant={"secondary"} size={"sm"}>{gettext('Create a new API key')}</Button></Link>
                    </div>
                </div>
            </div>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4 overflow-scroll">
                            <table className="table table-hover component-table">
                                <thead className="bold">
                                    <tr>
                                        <th>{gettext('Name')}</th>
                                        <th>{gettext('Prefix')}</th>
                                        <th>{gettext('Created at')}</th>
                                        <th>{gettext('Scope')}</th>
                                        <th>{gettext('Status')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {apikeys && apikeys.results.map(apikey =>
                                    <tr key={apikey.prefix}>
                                        <th>{apikey.name}</th>
                                        <td>{apikey.prefix}</td>
                                        <td>{apikey.created}</td>
                                        <td>{apikey.get_scope_display}</td>
                                        <td><ApiKeyStatus api_key={apikey} showText={false} /></td>
                                        <td className="text-center" onClick={(e) => showDeleteConfirm(e, apikey)}><SvgRecycleBin /></td>
                                    </tr>
                                    )} 
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Modal
                        show={isShowingDelete}
                        onClose={toggleDelete}
                        icon={<SvgRecycleBin />}
                        onClick={confirmDelete}
                        confirmButtonText={gettext('Confirm')}
                    >
                        <p><strong>{gettext('Are you sure you want to delete this api key?')}</strong></p>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default ApiKeys
